import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ADMIN_API } from '../common/common';
import { getDomain } from '../common/Funcation';
import { postApiAdmin } from '../service';

const pad = (n: number) => String(n).padStart(2, '0')

function formatCountdown(ms: number) {
  if (ms <= 0) return '00:00:00'
  const totalSeconds = Math.floor(ms / 1000)
  const days = Math.floor(totalSeconds / 86400)
  const hours = Math.floor((totalSeconds % 86400) / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60
  if (days > 0) return `${days}d ${pad(hours)}:${pad(minutes)}:${pad(seconds)}`
  return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`
}

const Maintenance = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const DD = useSelector((e: any) => e.domainDetails);
  const [now, setNow] = useState(Date.now())
  const closingRef = useRef(false)

  const endAt = DD?.maintenanceEndAt ? new Date(DD.maintenanceEndAt).getTime() : 0
  const remaining = endAt ? Math.max(0, endAt - now) : 0

  const refreshSite = async () => {
    try {
      const response = await postApiAdmin({
        api: ADMIN_API.SETTING.WEBSITE.GET_SITE,
        value: { domain: getDomain() },
      })
      if (response?.data?.data) {
        dispatch({ type: 'DOMAIN_DETAILS', payload: response.data.data })
        if (response.data.data.isMaintenance === false) {
          navigate('/login', { replace: true })
        }
      }
    } catch (err) {
      // Keep showing maintenance if the site check fails.
    }
  }

  useEffect(() => {
    if (DD?.isMaintenance === false) {
      navigate('/login', { replace: true })
    }
  }, [DD, navigate])

  useEffect(() => {
    const tick = setInterval(() => setNow(Date.now()), 1000)
    const poll = setInterval(refreshSite, 15000)
    return () => {
      clearInterval(tick)
      clearInterval(poll)
    }
  }, [])

  useEffect(() => {
    if (endAt && remaining <= 0 && !closingRef.current) {
      closingRef.current = true
      refreshSite().finally(() => {
        setTimeout(() => {
          closingRef.current = false
        }, 5000)
      })
    }
  }, [remaining, endAt])

  return (
    <>
      <div className='box'>
        <h2 className="">Watch this space!</h2>
        <p className="">We're currently improving our site and will be back in</p>
        <button type="button" className="">
          {endAt ? formatCountdown(remaining) : 'Soon'}
        </button>
        <p className="for">
          {endAt
            ? `Until ${new Date(endAt).toLocaleString()}`
            : "We'll be back shortly"}
        </p>
        <p className="">Apologies for any inconvenience this may cause.</p>
      </div>
    </>
  )
}

export default Maintenance
